module.exports = __webpack_public_path__ + "img/cancel-white.e94ed94d.svg";